import { type FunctionComponent, Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { TrelloRendererProps } from './TrelloRenderer';

export const LazyTrelloRenderer: FunctionComponent<TrelloRendererProps> = (
  props,
) => {
  const TrelloRenderer = useLazyComponent(
    () => import(/* webpackChunkName: "trello-renderer" */ './TrelloRenderer'),
    { namedImport: 'TrelloRenderer' },
  );

  return (
    <ErrorBoundary
      tags={{ ownershipArea: 'trello-web-eng', feature: 'Renderer' }}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <TrelloRenderer {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
